import { css, styled } from './theme-provider';

const Svg = styled.svg`
  ${({ theme }) => css`
    .st0 {
      fill: ${theme.color.brand_yarmill};
    }

    .st1 {
      fill: ${theme.color.neutral_white};
    }

    .st2 {
      display: none;
    }

    .st3 {
      display: inline;
      fill: none;
      stroke: ${theme.color.brand_yarmill_56};
      stroke-width: 3;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  `};
`;

export function YarmillLoader() {
  return (
    <Svg
      version="1.1"
      baseProfile="basic"
      imageRendering="auto"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 150 150"
      xmlSpace="preserve"
    >
      <g transform="translate(28 22.65)">
        <animateTransform
          accumulate="none"
          additive="replace"
          attributeName="transform"
          calcMode="discrete"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.01099;.011;.02199;.022;.03399;.034;.04499;.045;.05599;.056;.06699;.067;.07899;.079;.08999;.09;.10099;.101;.11199;.112;.12399;.124;.13499;.135;.14599;.146;.15699;.157;.16899;.169;.17999;.18;.19099;.191;.20199;.202;.21299;.213;.22499;.225;.23599;.236;.24699;.247;.25799;.258;.26999;.27;.28099;.281;.29199;.292;.30299;.303;.31499;.315;.32599;.326;.33699;.337;.34799;.348;.35999;.36;.37099;.371;.38199;.382;.39299;.393;.40399;.404;.41599;.416;.42699;.427;.43799;.438;.44899;.449;.46099;.461;.47199;.472;.48299;.483;.49399;.494;.50599;.506;.51699;.517;.52799;.528;.53899;.539;.55099;.551;.56199;.562;.57299;.573;.58399;.584;.59599;.596;.60699;.607;.61799;.618;.62899;.629;.63999;.64;.65199;.652;.66299;.663;.67399;.674;.68499;.685;.69699;.697;.70799;.708;.71899;.719;.72999;.73;.74199;.742;.75299;.753;.76399;.764;.77499;.775;.78699;.787;.79799;.798;.80899;.809;.81999;.82;.83099;.831;.84299;.843;.85399;.854;.86499;.865;.87599;.876;.88799;.888;.89899;.899;.90999;.91;.92099;.921;.93299;.933;.94399;.944;.95499;.955;.96599;.966;.97799;.978;.98899;.989;1"
          repeatCount="indefinite"
          restart="always"
          type="translate"
          values="75.6,76.1;75.6,76.1;75.649,76.149;75.649,76.149;75.651,76.148;75.651,76.148;75.653,76.146;75.653,76.146;75.703,76.094;75.703,76.094;75.659,76.139;75.659,76.139;75.666,76.182;75.666,76.182;75.627,76.173;75.627,76.173;75.691,76.111;75.691,76.111;75.684,76.139;75.684,76.139;75.655,76.168;75.655,76.168;75.633,76.194;75.633,76.194;75.64,76.156;75.64,76.156;75.698,76.11;75.698,76.11;75.694,76.12;75.694,76.12;75.668,76.164;75.668,76.164;75.649,76.151;75.649,76.151;75.684,76.125;75.684,76.125;75.645,76.132;75.645,76.132;75.649,76.187;75.649,76.187;75.621,76.127;75.621,76.127;75.655,76.195;75.655,76.195;75.692,76.199;75.692,76.199;75.735,76.189;75.735,76.189;75.687,76.168;75.687,76.168;75.803,76.2;75.803,76.2;75.693,76.223;75.693,76.223;75.734,76.206;75.734,76.206;75.813,76.268;75.813,76.268;75.721,76.251;75.721,76.251;75.705,76.224;75.705,76.224;75.693,76.307;75.693,76.307;75.722,76.287;75.722,76.287;75.709,76.197;75.709,76.197;75.777,76.283;75.777,76.283;75.811,76.23;75.811,76.23;75.762,76.255;75.762,76.255;75.794,76.256;75.794,76.256;75.727,76.243;75.727,76.243;75.737,76.223;75.737,76.223;75.809,76.224;75.809,76.224;75.731,76.274;75.731,76.274;75.745,76.303;75.745,76.303;75.708,76.248;75.708,76.248;75.715,76.229;75.715,76.229;75.813,76.224;75.813,76.224;75.717,76.238;75.717,76.238;75.817,76.216;75.817,76.216;75.772,76.273;75.772,76.273;75.77,76.274;75.77,76.274;75.68,76.21;75.68,76.21;75.73,76.26;75.73,76.26;75.776,76.254;75.776,76.254;75.733,76.315;75.733,76.315;75.817,76.253;75.817,76.253;75.717,76.273;75.717,76.273;75.703,76.3;75.703,76.3;75.772,76.199;75.772,76.199;75.704,76.186;75.704,76.186;75.727,76.207;75.727,76.207;75.793,76.253;75.793,76.253;75.801,76.189;75.801,76.189;75.792,76.3;75.792,76.3;75.724,76.294;75.724,76.294;75.732,76.267;75.732,76.267;75.682,76.258;75.682,76.258;75.703,76.248;75.703,76.248;75.709,76.336;75.709,76.336;75.744,76.331;75.744,76.331;75.802,76.401;75.802,76.401;75.783,76.421;75.783,76.421;75.783,76.397;75.783,76.397;75.755,76.431;75.755,76.431;75.778,76.448;75.778,76.448;75.775,76.44;75.775,76.44;75.803,76.395;75.803,76.395;75.778,76.402;75.778,76.402;75.783,76.479;75.783,76.479;75.85,76.446;75.85,76.446;75.777,76.451;75.777,76.451;75.812,76.546;75.812,76.546;75.73,76.476;75.73,76.476;75.783,76.453;75.783,76.453;75.714,76.517;75.714,76.517;75.804,76.478;75.804,76.478;75.746,76.484;75.746,76.484;75.743,76.487;75.743,76.487;75.793,76.49;75.793,76.49;75.693,76.393;75.693,76.393"
        />

        <animateTransform
          accumulate="none"
          additive="sum"
          attributeName="transform"
          calcMode="discrete"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.02199;.022;.03399;.034;.04499;.045;.05599;.056;.06699;.067;.07899;.079;.08999;.09;.10099;.101;.11199;.112;.12399;.124;.13499;.135;.14599;.146;.15699;.157;.16899;.169;.17999;.18;.19099;.191;.20199;.202;.21299;.213;.22499;.225;.23599;.236;.24699;.247;.25799;.258;.26999;.27;.28099;.281;.29199;.292;.30299;.303;.31499;.315;.32599;.326;.33699;.337;.34799;.348;.35999;.36;.37099;.371;.38199;.382;.39299;.393;.40399;.404;.41599;.416;.42699;.427;.43799;.438;.44899;.449;.46099;.461;.47199;.472;.48299;.483;.49399;.494;.50599;.506;.51699;.517;.52799;.528;.53899;.539;.55099;.551;.56199;.562;.58399;.584;.59599;.596;.60699;.607;.61799;.618;.62899;.629;.63999;.64;.65199;.652;.66299;.663;.67399;.674;.68499;.685;.69699;.697;.70799;.708;.71899;.719;.72999;.73;.74199;.742;.75299;.753;.76399;.764;.77499;.775;.78699;.787;.79799;.798;.80899;.809;.81999;.82;.83099;.831;.84299;.843;.85399;.854;.86499;.865;.87599;.876;.88799;.888;.89899;.899;.90999;.91;.92099;.921;.93299;.933;.94399;.944;.95499;.955;.96599;.966;.97799;.978;.98899;.989;1"
          repeatCount="indefinite"
          restart="always"
          type="rotate"
          values="0,0,0;0,0,0;-.003,0,0;-.003,0,0;-.009,0,0;-.009,0,0;-.022,0,0;-.022,0,0;-.044,0,0;-.044,0,0;-.076,0,0;-.076,0,0;-.121,0,0;-.121,0,0;-.181,0,0;-.181,0,0;-.257,0,0;-.257,0,0;-.353,0,0;-.353,0,0;-.47,0,0;-.47,0,0;-.611,0,0;-.611,0,0;-.777,0,0;-.777,0,0;-.97,0,0;-.97,0,0;-1.194,0,0;-1.194,0,0;-1.449,0,0;-1.449,0,0;-1.738,0,0;-1.738,0,0;-2.064,0,0;-2.064,0,0;-2.427,0,0;-2.427,0,0;-2.83,0,0;-2.83,0,0;-3.277,0,0;-3.277,0,0;-3.767,0,0;-3.767,0,0;-4.305,0,0;-4.305,0,0;-4.892,0,0;-4.892,0,0;-5.529,0,0;-5.529,0,0;-6.167,0,0;-6.167,0,0;-6.753,0,0;-6.753,0,0;-7.291,0,0;-7.291,0,0;-7.782,0,0;-7.782,0,0;-8.228,0,0;-8.228,0,0;-8.632,0,0;-8.632,0,0;-8.996,0,0;-8.996,0,0;-9.32,0,0;-9.32,0,0;-9.61,0,0;-9.61,0,0;-9.865,0,0;-9.865,0,0;-10.088,0,0;-10.088,0,0;-10.281,0,0;-10.281,0,0;-10.448,0,0;-10.448,0,0;-10.588,0,0;-10.588,0,0;-10.706,0,0;-10.706,0,0;-10.802,0,0;-10.802,0,0;-10.879,0,0;-10.879,0,0;-10.939,0,0;-10.939,0,0;-10.983,0,0;-10.983,0,0;-11.016,0,0;-11.016,0,0;-11.037,0,0;-11.037,0,0;-11.051,0,0;-11.051,0,0;-11.057,0,0;-11.057,0,0;-11.059,0,0;-11.059,0,0;-11.061,0,0;-11.061,0,0;-11.055,0,0;-11.055,0,0;-11.039,0,0;-11.039,0,0;-11.011,0,0;-11.011,0,0;-10.96,0,0;-10.96,0,0;-10.887,0,0;-10.887,0,0;-10.784,0,0;-10.784,0,0;-10.648,0,0;-10.648,0,0;-10.473,0,0;-10.473,0,0;-10.254,0,0;-10.254,0,0;-9.988,0,0;-9.988,0,0;-9.667,0,0;-9.667,0,0;-9.289,0,0;-9.289,0,0;-8.848,0,0;-8.848,0,0;-8.34,0,0;-8.34,0,0;-7.758,0,0;-7.758,0,0;-7.098,0,0;-7.098,0,0;-6.359,0,0;-6.359,0,0;-5.53,0,0;-5.53,0,0;-4.703,0,0;-4.703,0,0;-3.96,0,0;-3.96,0,0;-3.302,0,0;-3.302,0,0;-2.721,0,0;-2.721,0,0;-2.213,0,0;-2.213,0,0;-1.772,0,0;-1.772,0,0;-1.393,0,0;-1.393,0,0;-1.073,0,0;-1.073,0,0;-.806,0,0;-.806,0,0;-.587,0,0;-.587,0,0;-.412,0,0;-.412,0,0;-.276,0,0;-.276,0,0;-.174,0,0;-.174,0,0;-.101,0,0;-.101,0,0;-.052,0,0;-.052,0,0;-.02,0,0;-.02,0,0;-.006,0,0;-.006,0,0;-.001,0,0;-.001,0,0;.001,0,0;.001,0,0"
        />

        <animateTransform
          accumulate="none"
          additive="sum"
          attributeName="transform"
          calcMode="discrete"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.34799;.348;.77499;.775;1"
          repeatCount="indefinite"
          restart="always"
          type="scale"
          values="1,1;1,1;1,.999;1,.999;1,1;1,1"
        />

        <animateTransform
          accumulate="none"
          additive="sum"
          attributeName="transform"
          calcMode="discrete"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.01099;.011;.02199;.022;.04499;.045;.05599;.056;.07899;.079;.08999;.09;.11199;.112;.14599;.146;.15699;.157;.16899;.169;.17999;.18;.19099;.191;.20199;.202;.21299;.213;.22499;.225;.23599;.236;.24699;.247;.28099;.281;.29199;.292;.30299;.303;.31499;.315;.32599;.326;.33699;.337;.34799;.348;.35999;.36;.37099;.371;.38199;.382;.39299;.393;.40399;.404;.41599;.416;.42699;.427;.43799;.438;.44899;.449;.46099;.461;.48299;.483;.49399;.494;.50599;.506;.51699;.517;.52799;.528;.53899;.539;.56199;.562;.58399;.584;.59599;.596;.60699;.607;.61799;.618;.62899;.629;.63999;.64;.65199;.652;.66299;.663;.67399;.674;.70799;.708;.71899;.719;.72999;.73;.74199;.742;.76399;.764;.77499;.775;.78699;.787;.80899;.809;.81999;.82;.83099;.831;.84299;.843;.85399;.854;.86499;.865;.88799;.888;.89899;.899;.90999;.91;.92099;.921;.93299;.933;.94399;.944;.95499;.955;.97799;.978;.98899;.989;1"
          repeatCount="indefinite"
          restart="always"
          type="translate"
          values="-47.6,-53.45;-47.6,-53.45;-47.65,-53.5;-47.65,-53.5;-47.7,-53.5;-47.7,-53.5;-47.75,-53.45;-47.75,-53.45;-47.7,-53.5;-47.7,-53.5;-47.7,-53.55;-47.7,-53.55;-47.7,-53.5;-47.7,-53.5;-47.7,-53.55;-47.7,-53.55;-47.7,-53.5;-47.7,-53.5;-47.75,-53.5;-47.75,-53.5;-47.7,-53.55;-47.7,-53.55;-47.65,-53.55;-47.65,-53.55;-47.7,-53.55;-47.7,-53.55;-47.7,-53.5;-47.7,-53.5;-47.75,-53.55;-47.75,-53.55;-47.6,-53.5;-47.6,-53.5;-47.65,-53.55;-47.65,-53.55;-47.7,-53.55;-47.7,-53.55;-47.75,-53.55;-47.75,-53.55;-47.6,-53.45;-47.6,-53.45;-47.65,-53.45;-47.65,-53.45;-47.7,-53.55;-47.7,-53.55;-47.65,-53.55;-47.65,-53.55;-47.6,-53.5;-47.6,-53.5;-47.65,-53.55;-47.65,-53.55;-47.65,-53.6;-47.65,-53.6;-47.65,-53.45;-47.65,-53.45;-47.7,-53.55;-47.7,-53.55;-47.75,-53.5;-47.75,-53.5;-47.65,-53.55;-47.65,-53.55;-47.75,-53.55;-47.75,-53.55;-47.6,-53.55;-47.6,-53.55;-47.6,-53.5;-47.6,-53.5;-47.7,-53.5;-47.7,-53.5;-47.65,-53.55;-47.65,-53.55;-47.6,-53.55;-47.6,-53.55;-47.65,-53.55;-47.65,-53.55;-47.7,-53.55;-47.7,-53.55;-47.6,-53.55;-47.6,-53.55;-47.7,-53.55;-47.7,-53.55;-47.65,-53.55;-47.65,-53.55;-47.7,-53.6;-47.7,-53.6;-47.75,-53.6;-47.75,-53.6;-47.7,-53.65;-47.7,-53.65;-47.8,-53.6;-47.8,-53.6;-47.7,-53.6;-47.7,-53.6;-47.65,-53.6;-47.65,-53.6;-47.8,-53.55;-47.8,-53.55;-47.7,-53.55;-47.7,-53.55;-47.75,-53.55;-47.75,-53.55;-47.8,-53.6;-47.8,-53.6;-47.7,-53.6;-47.7,-53.6;-47.7,-53.55;-47.7,-53.55;-47.65,-53.55;-47.65,-53.55;-47.7,-53.5;-47.7,-53.5;-47.75,-53.55;-47.75,-53.55;-47.7,-53.6;-47.7,-53.6;-47.75,-53.6;-47.75,-53.6;-47.7,-53.55;-47.7,-53.55;-47.8,-53.6;-47.8,-53.6;-47.75,-53.55;-47.75,-53.55;-47.8,-53.5;-47.8,-53.5;-47.7,-53.55;-47.7,-53.55;-47.8,-53.55;-47.8,-53.55;-47.75,-53.55;-47.75,-53.55;-47.75,-53.6;-47.75,-53.6;-47.7,-53.6;-47.7,-53.6;-47.8,-53.5;-47.8,-53.5;-47.7,-53.6;-47.7,-53.6;-47.8,-53.55;-47.8,-53.55;-47.75,-53.5;-47.75,-53.5;-47.7,-53.5;-47.7,-53.5;-47.7,-53.65;-47.7,-53.65"
        />
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path
            className="st0"
            d="M467,207.1c-2.9-10.2-8.4-23.3-16.6-39.1c-8.7-17.2-14.3-29.7-16.9-37.6c-2.6-7-4.5-15.4-5.9-25.3
			c-0.5-2.9-1.4-11.8-2.8-26.6c-1-10.9-2.2-19.6-3.6-26.1c-2.2-9.4-5.4-17.4-9.5-24C400.3,9.8,381.3-2,354.8-7.1
			c-15.8-2.9-39.2-3.6-70-2c-40.2,2.2-69.2,13.6-86.9,34.3c-16.5,19.4-25,49.4-25.6,90c-0.5,5.8-0.7,13.5-0.5,23
			c0,5.3,0,13.4,0,24.3c0,19.9-1.6,34.7-4.9,44.2c-5.3,12.3-17.4,18.7-36.3,19.4c-5.8,0.2-14.1-0.3-25-1.3
			c-11.6-1-19.5-1.5-23.8-1.5c-47.5-0.7-77.4,9-89.7,29.1c-11.9,19.4-8.6,51.4,10,95.9c8.7,18.7,18.2,40.6,28.6,65.7
			c10.7,25.6,17.6,41.7,20.7,48.3c6.5,14.3,12.3,25.5,17.4,33.5c6,9.2,12.4,16.4,19.2,21.5c7.2,5.5,15.8,9.5,25.8,12.3
			c9.5,2.6,21.8,4.3,36.8,5.4c12.4,0.9,30.2,1.4,53.2,1.5c14,0,38.7,0,74.1,0c7,0,18.1-0.1,33.2-0.3c13.5-0.2,24.9-1,34.3-2.6
			c26.1-4.1,45.2-13.7,57.3-28.9c7.5-10.6,12.9-25.5,16.1-44.7c0.7-4.3,1.7-12.4,3.1-24.5c1.2-10.2,2.4-18.1,3.6-23.8
			c2.6-14,7.4-30.8,14.6-50.6c8.5-22,14.7-38.5,18.4-49.6c6.5-19.1,10.6-36,12.3-50.6c2.2-18.4,1-36.1-3.6-53.2V207.1z"
          />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path
            className="st1"
            d="M94.5,338.5l40.6-66.7h-24.5l-26.6,44.7l-26.3-44.7H32.2L72.8,339v45h21.7V338.5z"
          />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path
            className="st1"
            d="M134.9,339.5c-6,4.8-8.9,11.4-8.9,19.9c0,7.8,2.7,14.1,8.2,18.7c5.5,4.6,12.9,6.9,22.2,6.9
			c6,0,11.4-1.2,16.4-3.6c4.8-2.4,8.2-5.5,10.2-9.5v11.8h21.2v-55.2c0-11.1-3.7-19.8-11-26.1c-7.2-6-16.5-8.9-28.1-8.9
			c-10.6,0-19.5,3.1-26.8,9.2c-7.2,6-11.2,13.6-12.3,23h20.2c0.7-4.9,2.6-8.8,5.9-11.5c3.2-2.7,7.6-4.1,13-4.1c5.5,0,9.8,1.4,13,4.1
			c3.2,2.9,4.9,6.8,4.9,11.8v1.8l-19.7,2.3C150.5,331.4,141.1,334.5,134.9,339.5 M150.5,365.8c-2.4-1.9-3.6-4.3-3.6-7.4
			c0-3.4,1.4-6.2,4.1-8.4c2.9-2.2,7.1-3.7,12.5-4.3l19.4-2c0,7.7-2.1,13.8-6.4,18.4c-4.1,4.4-9.5,6.6-16.4,6.6
			C156.3,368.6,153.1,367.7,150.5,365.8z"
          />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path
            className="st1"
            d="M279.4,295.3c-3.1-1.2-6.6-1.8-10.5-1.8c-5.3,0-10.2,1.3-14.8,3.8c-4.8,2.6-8.3,5.9-10.5,10v-12.5h-21v88.2
			h21v-32.5c0-12.3,2.4-21.7,7.2-28.4c4.3-6,9.9-8.9,16.9-8.9c4.3,0,8.2,0.8,11.8,2.3V295.3z"
          />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path
            className="st1"
            d="M402.3,235.7c-0.3,0.3-0.9,0.5-1.8,0.5c-4.3-0.3-7.7-0.9-10.2-1.5l-2.8-1l0.3,0.3c0.3,0.3,0.7,0.8,1,1.3
			l-14.8,10.2c1.5,2.2,4,4.1,7.4,5.6c4.6,1.9,10.7,3,18.1,3.3h1.3c5.5,0,10.1-1.9,14.1-5.6c4.3-4.3,7.1-10.7,8.4-19.4
			c0.9-4.9,1.2-11.6,1-19.9v-2.3h-17.9v2.6C406.6,224,405.2,232.6,402.3,235.7z"
          />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path
            className="st1"
            d="M378.3,51.9c-2.7-4.4-6.6-7.9-11.8-10.5c-4.9-2.7-10.1-4.2-15.6-4.3h-0.5c-9.5,0-18.8,7.8-27.9,23.5
			c-8,14-16.8,36.3-26.3,67c-0.3-20.4-1.9-36.7-4.6-48.8c-3.4-14.8-8.9-25.3-16.6-31.4c-3.4-2.7-7.3-4.5-11.8-5.4
			c-4.4-1-9.1-0.9-14.1,0.3c-10.4,2.4-17.2,8.3-20.4,17.6c-1.9,5.5-2.7,14.7-2.6,27.6v5.9c0,14.5,0.3,54.8,0.8,120.9v9.5l9.5-0.5
			c8.7-0.7,17.9-1.1,27.6-1.3c13.5-0.3,23.3,0,29.7,1c0.7,2.2,1.3,4.8,1.8,7.7c0.3,3.7,0.3,7.2-0.3,10.2c-0.7,3.6-2.1,6-4.3,7.4
			c-4.4,3.1-14.1,5.3-29.1,6.6c-11.9,1-24,1.3-36.3,0.8l-0.8,18.1c0.7,0,3.9,0,9.7,0h0.3c7.2,0,13.9-0.2,20.2-0.5
			c22.5-1.2,37.9-4.5,46.3-10c5.1-3.4,8.7-8.4,10.7-15.1c2-6.8,2.4-14.4,1-22.7c-2-11.4-6-17.9-12-19.4c-6-1.4-15.1-2.1-27.3-2.3
			c-8.7,0-18.2,0.3-28.6,0.8c-0.3-50.6-0.5-87.7-0.5-111.2l-0.3-5.9c0-11.1,0.5-18.2,1.5-21.5c1.2-3.2,3.8-5.3,7.9-6.1
			c2.4-0.7,4.5-0.8,6.4-0.3c1.4,0.3,2.6,0.9,3.8,1.8c6.6,5.5,11,19,13,40.6c1.2,12.3,1.6,29.8,1.3,52.7c-0.2,10.4-0.2,17.3,0,20.7
			c0.2,2.7,1.1,5.1,2.8,7.2c1.9,1.9,4.2,3,6.9,3.3c2.6,0.3,5-0.2,7.4-1.5c2.2-1.5,3.7-3.6,4.6-6.1l4.1-13.8
			c8.9-30.8,16.6-54.5,23.3-71.1c6-14.8,11.7-25.6,17.1-32.5c2.7-3.2,4.9-5.1,6.4-5.6c2.2-1,4.7-0.8,7.4,0.8
			c2.2,1.2,4.1,2.9,5.6,5.1c1.7,2.7,1.6,6.3-0.3,10.7c-6,13.6-11.3,27.7-16.1,42.2c-7.2,21-12.7,41.2-16.6,60.6
			c-1.5,7.5-2.5,17.1-2.8,28.9c-0.2,6.3-0.3,14.4-0.3,24.3c0.2,11.2,1.6,20.3,4.3,27.1c2.7,6.8,6.9,12,12.5,15.6
			c2.6,1.5,6.5,2.5,11.8,2.8c4.9,0.3,9.3,0,13-1c5.6-1.2,9.6-3.7,12-7.4c3.4-5.5,5.9-13.5,7.4-24.3c1.7-13,2.6-32.4,2.6-58.3h-17.9
			c0,23.3-0.8,41.2-2.3,53.4c-1,8.9-2.6,15.2-4.6,18.9c-1.4,0.5-3.5,0.8-6.4,0.8c-2.7,0-4.9-0.3-6.6-0.8c-4.9-3.2-7.5-12.3-7.7-27.1
			c-0.3-22.3,0.5-38.8,2.6-49.3c3.9-18.7,9.3-38.3,16.1-58.5c4.6-14,9.7-27.5,15.3-40.6c2-4.8,3-9.5,2.8-14.1
			C382.3,60.2,380.8,55.8,378.3,51.9z"
          />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path
            className="st1"
            d="M141.3,426.4c3.6-5.5,8.6-8.2,15.1-8.2c4.9,0,8.9,1.6,11.8,4.9c2.7,3.2,4.1,7.6,4.1,13V489h21.2v-38.9
			c0-10.1,1.9-18,5.6-23.8c3.6-5.6,8.7-8.4,15.3-8.4c4.8,0,8.6,1.7,11.5,5.1c2.9,3.2,4.3,7.6,4.3,13V489h21.2v-58
			c0-9.4-2.9-17-8.7-22.7c-5.8-5.8-13.3-8.7-22.5-8.7c-6,0-11.5,1.3-16.6,3.8c-5.6,2.9-10.3,7.1-14.1,12.5
			c-2.2-5.1-5.7-9.2-10.5-12.3c-4.9-2.7-10.5-4.1-16.6-4.1c-6,0-11.4,1.3-16.4,3.8c-4.8,2.6-8.3,5.6-10.5,9.2v-11.8h-21.2V489h21.2
			v-38.9C135.7,440.1,137.6,432.2,141.3,426.4z"
          />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path
            className="st1"
            d="M290.6,400.3h-20.7V489h20.7V400.3 M267.9,378.6c0,3.4,1.2,6.2,3.6,8.4c2.4,2.4,5.4,3.6,8.9,3.6
			c3.6,0,6.5-1.2,8.7-3.6c2.4-2.2,3.6-5,3.6-8.4c0-3.6-1.2-6.5-3.6-8.7c-2.4-2.2-5.3-3.3-8.7-3.3c-3.6,0-6.6,1.1-8.9,3.3
			C269,372.1,267.9,375,267.9,378.6z"
          />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path className="st1" d="M329.7,376H309v113.2h20.7V376z" />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path className="st1" d="M370.9,489.3V376h-20.7v113.2H370.9z" />
        </g>
        <g transform="matrix(.201 0 0 .201 0 0)">
          <path
            className="st1"
            d="M418.1,272h-17.9c0,10.2-0.9,18.6-2.6,25c-2,8.7-5.9,15.8-11.5,21.5c-13.6,14-39.4,21-77.2,21v17.9
			c22,0,40.4-2.2,55.2-6.6c15-4.4,26.8-11.2,35.5-20.2c5.5-5.8,9.6-12.4,12.5-19.7C416.2,300.5,418.1,287.5,418.1,272z"
          />
        </g>
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M108.2,19.5c-1.5-0.2-3.7-0.2-6.4,0 M106.5,23.9h2.9"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.933;.966;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M110.4,19c2.6-0.3,5,0.2,7,1.4c1.8,1,3.2,2.5,4.2,4.4 M120.6,32.5
		c-2-5.8-6.5-8.7-13.6-8.6"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.899;.933;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M124.7,39.5c0.8-0.8,1.2-2.6,1.2-5.4c0-1.3-0.2-2.5-0.5-3.7 M107.8,47.8
		c-0.1,0.1-0.2,0.1-0.3,0.2 M120.7,37.7c-0.7,1.9-1.9,3.5-3.6,4.9c-1.3,1.1-3.1,2.2-5.5,3.3 M104.8,23.5c4.5,0,7.9,0.5,10.3,1.6
		c2.7,1.3,4.5,3.5,5.6,6.6"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.865;.899;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M124.8,38.6c0,0.7-0.5,1.8-1.4,3.2 M120.8,36c-1.2,4.9-6.2,9.2-14.9,12.9
		c-0.1,0-0.2,0.1-0.2,0.1 M100.8,51c-5,1.7-10,2.8-15,3.5 M74.1,60.5h3.2c2.6,0,4.8-0.3,6.7-0.9"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.831;.865;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M103.8,50c-6.5,2.1-13.6,3.7-21.3,4.8c-8.3,1.2-14.2,1.4-17.7,0.5 M66.2,63.5h0.8
		c0.4,0.1,1.3,0.2,2.7,0.3c1.2,0.1,2.2,0.2,2.9,0.2c1.5,0,3.9-0.3,7.1-0.9"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.798;.831;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M58.3,46c-1.8,1.2-2.7,2.9-2.7,5.2c0,3.8,2.7,5.9,8.2,6.4c1.2,0.1,4.7,0,10.3-0.5
		 M53.9,60.8c1.1,0.5,2.9,0.9,5.3,1.4c2.5,0.5,4.1,0.6,4.9,0.5"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.764;.798;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M118.7,40.7c2.6,1,4.2,2.1,4.9,3.2 M59.2,46.2c-1.4,0.5-2.4,1.3-3.1,2.2"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.73;.764;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M117.7,62c1.1-1.6,2-3.5,2.7-5.6c0.4-1.9,0.6-2.8,0.6-2.9c0-4.1-1.8-7-5.3-8.7
		 M125.8,47c0.6,1,0.9,2,1.1,3c0,0.3,0.1,1,0.1,2.1c0,1.1-0.2,2.9-0.8,5.2"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.697;.73;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M115.8,64.4c0.3-0.4,0.7-0.9,0.9-1.3c2.7-4,4.1-7.8,4.2-11.4c0-0.3,0-0.8-0.1-1.2
		c-0.1-0.5-0.2-0.9-0.2-1.1 M103.1,75.8c3.3-2.1,6.2-4.4,8.7-6.8 M126.6,57c-0.1,3-1.2,6-3.3,9c-1.3,2-2.8,3.6-4.4,5"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.663;.697;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M79.8,87.8c5.6-1.9,12.5-5.4,20.7-10.8c9.3-6.1,15.2-11.4,17.4-15.9"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.629;.663;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M53.4,89.8c0.2,0,1.3,0.1,3.3,0.2c2.1,0.1,3.3,0.2,3.8,0.2c5.5,0,10.9-0.5,16.3-1.6
		c2.8-0.6,6.1-1.8,9.9-3.5c2-0.9,4.6-2.3,7.8-4.1"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.596;.629;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M9.8,76.1c2.2,2.9,3.4,4.6,3.7,5c1.2,1.4,2.4,2.5,3.7,3.3 M24.7,83.7
		c5.6,2.4,11.4,4.1,17.6,5.1c5.3,0.9,11.1,1.3,17.5,1.3c3.5,0,6.4-0.2,8.8-0.7"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.562;.596;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M14.2,65.2c-2,2.2-3.2,3.8-3.8,5.1c-0.4,0.9-0.6,2.4-0.6,4.5c0,2.4,1.2,4.8,3.7,7.3
		 M23.2,66.6c-3.9,2.1-5.6,4.9-5.2,8.2c0.5,3.4,3,6.5,7.8,9.1c2.7,1.5,6.4,2.9,11,4.3"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.528;.562;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M17.9,63c-2.2,1.4-3.9,2.9-5.1,4.5c-1.1,1.4-1.8,2.8-1.9,4.1 M18.3,71.1
		c2.2-3.3,5.6-5.5,10.2-6.5 M35,63.9c3.1-0.1,6.9,0.1,11.6,0.5"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.506;.528;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M18.2,71.1c2.5-3.8,6.6-6.1,12.2-6.9c3.4-0.5,8.8-0.4,16.1,0.3"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.483;.506;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path className="st3" d="M39,64.1h3.6c3.6,0.2,8.5,1,14.8,2.4" />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.449;.483;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M126.7,79.8c0.7,0.3,2,1.1,3.8,2.2c0.3,0.2,0.8,0.6,1.4,1.1c0.7,0.6,1.1,1,1.1,1.2"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.416;.449;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M132.8,83.6c1.5,0.6,2.6,1.6,3.2,3c0.5,0.9,0.7,1.9,0.7,3c0,1.2-0.2,2.4-0.6,3.6
		c-0.4,1.1-0.9,2.1-1.5,2.8 M128.7,92.6c-0.2,1.2-0.9,2.6-2.1,4.2 M121.4,83.8c1.9,1.1,3.7,2.5,5.3,4.2"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.382;.416;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M123.2,85.1c1.8,1.2,3.2,2.3,4,3.3c0.8,0.9,1.2,1.8,1.4,2.8c0.6,2.9-1.5,6-6.4,9.3
		c-3.8,2.5-8.3,4.7-13.6,6.5 M134.1,96.2c-0.8,2.2-1.5,3.8-2.2,4.8c-1.4,2-3.5,4-6.4,5.8"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.348;.382;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M119.6,102.1c-6.1,3.3-12.7,6.1-19.8,8.4c-7.4,2.4-14.2,4-20.3,4.7"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.315;.348;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M94.3,112.1c-7.2,1.7-14.4,3.2-21.7,4.3c-7.3,1.2-13.2,2-17.6,2.2 M39.2,126.5
		c1.2-0.1,2.9-0.5,5.3-1"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.292;.315;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M39.2,126.5c0.4-0.1,1.4-0.3,3-0.6c1.4-0.2,2.2-0.3,2.2-0.4 M94.3,112.1
		c-7.2,1.7-14.4,3.2-21.7,4.3c-7.3,1.2-13.2,2-17.6,2.2"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.27;.292;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M71.4,116.9l-8.4,1c-6.8,0.7-11.9,1.2-15.2,1.5 M22.9,123.5c2.1,1.6,4,2.6,5.7,3.1
		c1.4,0.4,3.3,0.4,5.6,0.2 M41.8,119.9c-3.4,0.2-6.3,0.2-8.8,0"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.236;.27;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M43.8,119.4c-5.2,0.8-9.1,0.9-11.8,0.2c-3.2-0.8-4.8-2.6-4.8-5.5c0-2.7,0.9-4.7,2.8-6
		c1.5-1,3.6-1.7,6.5-1.9 M21.5,120.1c0.1,2.2,1,3.8,2.7,4.8c1.2,0.8,3.1,1.4,5.6,1.9"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.202;.236;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path className="st3" d="M28.3,109.3c3.1-1.9,5.8-3.2,8.2-4" />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.169;.202;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M125.9,120.2c1,0.9,1.6,1.8,1.9,2.5c0.3,0.9,0.3,2.1,0.1,3.6c-0.3,1.8-0.5,3-0.7,3.5
		c-0.2,0.8-0.7,1.7-1.3,2.6 M113.8,113.5c4.7,3.2,6.8,7.6,6.2,13.3"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.135;.169;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M121.5,135.9c2.2-0.6,4-2.9,5.3-7 M113.7,113.2c1.5,1,2.8,2,3.7,3.1
		c1.9,2.2,2.9,5.2,2.9,8.8c0,3.1-2,6-6.2,8.6c-0.9,0.6-1.7,1.1-2.6,1.5 M107.6,136.8c-1.6,0.5-3.3,0.8-5,1"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.112;.135;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M113.7,113.2c1.5,1,2.8,2,3.7,3.1c1.9,2.2,2.9,5.2,2.9,8.8c0,3.1-2,6-6.2,8.6
		c-3.7,2.4-7.5,3.7-11.5,4.1"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.09;.112;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M84.2,132.4c0.8,1.2,3.1,2.3,6.8,3.4c3.6,1,6.6,1.6,9.1,1.6c3.8,0,7.3-0.5,10.4-1.4
		c4.1-1.3,7-3.2,8.7-5.9"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.056;.09;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
      <g className="st2">
        <path
          className="st3"
          d="M80.2,129.1c1.7,1.8,3.7,3.3,6.1,4.6c2.2,1.2,4.4,2,6.6,2.4"
        />

        <animate
          accumulate="none"
          additive="replace"
          attributeName="display"
          calcMode="linear"
          dur="1.78s"
          fill="remove"
          keyTimes="0;.022;.056;1"
          repeatCount="indefinite"
          restart="always"
          values="none;inline;none;none"
        />
      </g>
    </Svg>
  );
}
